<template>
  <div class="w-100">
    <b-container>
      <ImgBlock
        :title="$t('main.purchasePlan.merchBlock.title')"
        :btn-text="$t('main.purchasePlan.merchBlock.button')"
        :to="
          $urlBuilder('search', {
            path: 'merch-designs',
            keyword: 't-shirt'
          })
        "
      >
        <template #description>
          <span class="font-weight-bold">{{ $t('main.purchasePlan.merchBlock.text') }}</span>
          {{ $t('main.purchasePlan.merchBlock.text2') }}
        </template>
        <template #img>
          <picture>
            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/tshirt-bussines.jpg?fmt=webp&w=300"
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/tshirt-bussines.jpg?fmt=webp"
              type="image/webp"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/tshirt-bussines.jpg"
              type="image/jpeg"
            />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/purchase-plan/tshirt-bussines.jpg"
              :alt="$t('main.purchasePlan.merchBlock.altImage1')"
              height="525"
              width="446"
              loading="lazy"
            />
          </picture>
        </template>
      </ImgBlock>
    </b-container>

    <b-container>
      <ImgBlock
        :title="$t('main.purchasePlan.merchBlock.title2')"
        :right="true"
        :btn-text="$t('main.purchasePlan.merchBlock.button2')"
        :to="
          $urlBuilder('search', {
            path: 'merch-psd',
            keyword: 't-shirt-template'
          })
        "
      >
        <template #description>
          {{ $t('main.purchasePlan.merchBlock.text3') }}
          <span class="font-weight-bold">{{ $t('main.purchasePlan.merchBlock.text4') }}</span
          >.
          <a target="_blank" :href="$urlBuilder('landing', { uid: 'psd-t-shirt-designs' })">{{
            $t('main.purchasePlan.merchBlock.text5')
          }}</a>
        </template>
        <template #img>
          <picture>
            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/exclusive-designs.jpg?fmt=webp&w=300"
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/exclusive-designs.jpg?fmt=webp"
              type="image/webp"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/exclusive-designs.jpg"
              type="image/jpeg"
            />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/purchase-plan/exclusive-designs.jpg"
              :alt="$t('main.purchasePlan.merchBlock.altImage2')"
              height="525"
              width="446"
              loading="lazy"
            />
          </picture>
        </template>
      </ImgBlock>
    </b-container>

    <b-container>
      <ImgBlock :title="$t('main.purchasePlan.merchBlock.title3')">
        <template #description>
          {{ $t('main.purchasePlan.merchBlock.text6') }}
          <a target="_blank" href="https://www.vexels.com/t-shirt-maker">{{
            $t('main.purchasePlan.merchBlock.text7')
          }}</a
          >.
        </template>
        <template #img>
          <picture>
            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/tshirt-maker.jpg?fmt=webp&w=300"
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/tshirt-maker.jpg?fmt=webp"
              type="image/webp"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/tshirt-maker.jpg"
              type="image/jpeg"
            />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/purchase-plan/tshirt-maker.jpg"
              :alt="$t('main.purchasePlan.merchBlock.altImage3')"
              height="525"
              width="446"
              loading="lazy"
            />
          </picture>
        </template>
      </ImgBlock>
    </b-container>

    <b-container>
      <ImgBlock :title="$t('main.purchasePlan.merchBlock.title4')" :right="true">
        <template #description>
          <a
            target="_blank"
            :href="$urlBuilder('search', { path: 'merch-vectors', keyword: 'book-cover' })"
            >{{ $t('main.purchasePlan.merchBlock.text8') }}</a
          >,
          <a
            target="_blank"
            :href="$urlBuilder('search', { path: 'merch-vectors', keyword: 'phone-cases' })"
            >{{ $t('main.purchasePlan.merchBlock.text9') }}</a
          >,
          <a
            target="_blank"
            :href="$urlBuilder('search', { path: 'merch-vectors', keyword: 'popsockets' })"
            >{{ $t('main.purchasePlan.merchBlock.text10') }}</a
          >,
          <a
            target="_blank"
            :href="$urlBuilder('search', { path: 'merch-vectors', keyword: 'face-mask' })"
            >{{ $t('main.purchasePlan.merchBlock.text11') }}</a
          >.
        </template>
        <template #img>
          <picture>
            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/not-only-tshirts.jpg?fmt=webp&w=300"
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/not-only-tshirts.jpg?fmt=webp"
              type="image/webp"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/not-only-tshirts.jpg"
              type="image/jpeg"
            />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/purchase-plan/not-only-tshirts.jpg"
              :alt="$t('main.purchasePlan.merchBlock.altImage4')"
              height="525"
              width="446"
              loading="lazy"
            />
          </picture>
        </template>
      </ImgBlock>
    </b-container>

    <b-container>
      <ImgBlock :title="$t('main.purchasePlan.merchBlock.title5')">
        <template #description> {{ $t('main.purchasePlan.merchBlock.text12') }} </template>
        <template #img>
          <picture>
            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/merchandise-alive.jpg?fmt=webp&w=300"
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/merchandise-alive.jpg?fmt=webp"
              type="image/webp"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/merchandise-alive.jpg"
              type="image/jpeg"
            />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/purchase-plan/merchandise-alive.jpg"
              :alt="$t('main.purchasePlan.merchBlock.altImage5')"
              height="525"
              width="446"
              loading="lazy"
            />
          </picture>
        </template>
      </ImgBlock>
    </b-container>

    <b-container>
      <ImgBlock
        :title="$t('main.purchasePlan.merchBlock.title6')"
        :right="true"
        :btn-text="$t('main.purchasePlan.merchBlock.button6')"
        to="https://mockups.vexels.com/"
      >
        <template #description> {{ $t('main.purchasePlan.merchBlock.text13') }} </template>
        <template #img>
          <picture>
            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/mockup-gen.jpg?fmt=webp&w=300"
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/mockup-gen.jpg?fmt=webp"
              type="image/webp"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/mockup-gen.jpg"
              type="image/jpeg"
            />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/purchase-plan/mockup-gen.jpg"
              :alt="$t('main.purchasePlan.merchBlock.altImage6')"
              height="525"
              width="446"
              loading="lazy"
            />
          </picture>
        </template>
      </ImgBlock>
    </b-container>

    <b-container>
      <ImgBlock
        :title="$t('main.purchasePlan.merchBlock.title7')"
        :btn-text="$t('main.purchasePlan.merchBlock.button7')"
        to="https://www.vexels.com/blog/vexels-design-request-guide/"
      >
        <template #description> {{ $t('main.purchasePlan.merchBlock.text14') }} </template>
        <template #img>
          <picture>
            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/cant-find.jpg?fmt=webp&w=300"
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/cant-find.jpg?fmt=webp"
              type="image/webp"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/cant-find.jpg"
              type="image/jpeg"
            />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/purchase-plan/cant-find.jpg"
              :alt="$t('main.purchasePlan.merchBlock.altImage7')"
              height="525"
              width="446"
              loading="lazy"
            />
          </picture>
        </template>
      </ImgBlock>
    </b-container>

    <b-container>
      <ImgBlock :title="$t('main.purchasePlan.merchBlock.title8')" :right="true">
        <template #description> {{ $t('main.purchasePlan.merchBlock.text15') }} </template>
        <template #img>
          <picture>
            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/design-bundle.jpg?fmt=webp&w=300"
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/design-bundle.jpg?fmt=webp"
              type="image/webp"
            />

            <source
              srcset="https://cdn.vexels.com/img/purchase-plan/design-bundle.jpg"
              type="image/jpeg"
            />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/purchase-plan/design-bundle.jpg"
              :alt="$t('main.purchasePlan.merchBlock.altImage8')"
              height="525"
              width="446"
              loading="lazy"
            />
          </picture>
        </template>
      </ImgBlock>
    </b-container>
  </div>
</template>

<script>
import ImgBlock from './ImgBlock';

export default {
  name: 'PurchasePlan',
  components: {
    ImgBlock
  }
};
</script>
